module.exports = __webpack_public_path__ + "static/media/45-250x250.6b011cb4.jpg";